export const getPdfViewerUrl = (url: string): string => {
    const encodedUrl = btoa(url);
    return `/library/book-view/${encodedUrl}`;
};
